import * as React from "react";
import { Avatar } from "primereact/avatar";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";

import MenuIcon from "@mui/icons-material/Menu";
import { useState, useRef } from "react";
// import { Test } from "./pages/test/test";
import "primeicons/primeicons.css";
import { Toast } from "primereact/toast";
// import { Test } from "./pages/test/test";
import { Logout } from "./pages/logout/logoutPage/logout";
import Typography from "@mui/material/Typography";
import Logo from "./assets/logo.png";
import Navbar from "./component/Navbar";
import NavbarGauche from "./component/NavbarGauche";
import "./App.css";

import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Login } from "./pages/login/loginPage/login";
import { Stockage } from "./pages/stockage/stockage";
import { StockageRetard } from "./pages/stockageRetard/stockageRetard";
import { Client } from "./pages/client/ClientPage/client";
import { Reglement } from "./pages/reglement/reglementPage/Reglement";
import { Users } from "./pages/users/usersPage/users";
import { Contrat } from "./pages/contrat/contratPage/contrat";

import Tasklist from "./pages/tasklist/tasklist";
import FicheListe from "./pages/fiche/fiche";
import FicheDemandeListe from "./pages/ficheDemande/ficheDem";

import { Dash } from "./pages/dashboard/dashboardPage/dash";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LocationStockage } from "./pages/location/locationPage/locationStockage";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect } from "react";
import { Facture } from "./pages/facture/facturePage/facture";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "./styles/NavbarGauche.css";
import { Modal } from "@mui/material";
// import { Menu } from "primereact/menu";
import ReactDOM from "react-dom";

import LeadsList from "./pages/leads/leads";
import HistoriqueMailSuivi from "./pages/leads/historiqueMailSuivi";

import { OverlayPanel } from "primereact/overlaypanel";

import "primeflex/primeflex.css";
import { PrimeReactProvider } from "primereact/api";

const drawerWidth = 240;
function App(props) {
  const isMobilePortrait = useMediaQuery("(max-width:1400px) ");

  const [nomPageActive, setNomPageActive] = useState("Leads");
  const locationGauche = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const op = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  let items = [
    {
      label: "Déconnexion",
      icon: "pi pi-power-off",
      command: () => {
        setdeconnect(true);
      },
    },
  ];
  if (localStorage.getItem("us") === "admin") {
    items.unshift({
      label: "Utilisateurs",
      icon: "pi pi-users",
      command: () => {
        navigate("/users");
      },
    });
  }

  const [deconnectHovered, setDeconnectHovered] = useState(false);

  const [deconnect, setdeconnect] = useState(false);

  const [isConfirmingLogout, setIsConfirmingLogout] = useState(false);
  const logoutTimeoutRef = useRef(null);

  const toggleLogoutMode = (e) => {
    e.stopPropagation();
    if (!isConfirmingLogout) {
      setIsConfirmingLogout(true);
      logoutTimeoutRef.current = setTimeout(() => {
        setIsConfirmingLogout(false);
      }, 3000);
    }
  };

  useEffect(() => {
    return () => {
      if (logoutTimeoutRef.current) clearTimeout(logoutTimeoutRef.current);
    };
  }, []);

  const handleLogout = () => {
    setdeconnect(true);
  };

  const drawer = (
    <div className="navbarGauche">
      <div className="flex align-items-center mb-5 px-2">
        <img
          src={Logo}
          alt="Logo"
          style={{
            marginLeft: "5%",
            width: "100px",
            display: "block",
          }}
        />
      </div>

      <div className="flex-grow-1">
        <Link
          to="/LeadsList"
          className={
            locationGauche.pathname === "/LeadsList" ? "activeLink" : "ty"
          }
        >
          <i className="pi pi-users mr-2"></i>
          <span>Leads</span>{" "}
        </Link>

        <a
          href="https://drive.google.com/drive/folders/1taQ4Iif3n_H0rYhqlBB6fH-WVfzV0RPt?usp=drive_link"
          target="_blank"
          className="ty"
        >
          <i className="pi pi-file mr-2"></i>
          <span>Plaquettes</span>
        </a>
      </div>

      <div
        className="sidebar-footer"
        onClick={toggleLogoutMode}
        style={{
          cursor: "pointer",
          padding: "12px",
          borderRadius: "12px",
          backgroundColor: isConfirmingLogout ? "#ff4d4d1a" : "transparent",
          transition: "all 0.3s ease",
          minHeight: "60px",
        }}
      >
        {!isConfirmingLogout ? (
          <>
            <Avatar
              label={localStorage.getItem("us")?.charAt(0).toUpperCase()}
              shape="circle"
              style={{
                backgroundColor: "#f1bd40",
                color: "#000",
                flexShrink: 0,
              }}
            />
            <div
              className="flex-grow-1 overflow-hidden"
              style={{ lineHeight: "1.2" }}
            >
              <div
                style={{
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  color: "white",
                  whiteSpace: "nowrap",
                }}
              >
                {localStorage.getItem("us") || "Admin"}
              </div>
              <div style={{ fontSize: "0.75rem", color: "#666" }}>
                Gestionnaire
              </div>
            </div>
            <i
              className="pi pi-sign-out"
              style={{ color: "#444", fontSize: "1rem" }}
            ></i>
          </>
        ) : (
          <div
            className="flex-grow-1 flex align-items-center justify-content-between animation-duration-200 fadein"
            onClick={(e) => {
              e.stopPropagation();
              handleLogout();
            }}
            style={{ color: "#f1bd40" }}
          >
            <span style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
              Se déconnecter
            </span>
            <i className="pi pi-power-off" style={{ fontSize: "0.9rem" }}></i>
          </div>
        )}
      </div>
    </div>
  );

  const toast = useRef(null);
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <PrimeReactProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {" "}
        <Box sx={{ display: "flex" }}>
          <ToastContainer />
          <Toast ref={toast} />
          <CssBaseline />
          <Modal
            open={deconnect}
            disableBackdropClick={true}
            aria-describedby="modal-modal-description"
          >
            <Logout onClose={() => setdeconnect(false)} />
          </Modal>
          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              position: "fixed",
              width: "100%",
              height: "65px",
              backgroundColor: "#111",
              alignItems: "center",
              px: 2,
              zIndex: 1100,
              borderBottom: "1px solid #222",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <IconButton
                onClick={handleDrawerToggle}
                sx={{ color: "white", p: 0 }}
              >
                <MenuIcon />
              </IconButton>

              <div style={{ lineHeight: "1.2" }}>
                <Typography
                  sx={{ color: "white", fontSize: "0.9rem", fontWeight: "600" }}
                >
                 Un P'tit tuk
                </Typography>
                <Typography sx={{ color: "#666", fontSize: "0.75rem" }}>
                  Leads
                </Typography>
              </div>
            </div>

            <Avatar
              label={localStorage.getItem("us")?.charAt(0).toUpperCase()}
              shape="circle"
              style={{
                backgroundColor: "#f1bd40",
                color: "#000",
                width: "32px",
                height: "32px",
                fontSize: "0.8rem",
              }}
            />
          </Box>
          <Box
            component="nav"
            sx={{
              width: { sm: drawerWidth },
              flexShrink: { sm: 0 },
            }}
            aria-label="mailbox folders"
          >
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xs: "block", sm: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
            >
              {drawer}
            </Drawer>
            <Drawer
              variant="permanent"
              style={{ overflow: " hidden" }}
              sx={{
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: "auto",
                  height: "auto",
                },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
          <Box
            component="main"
            sx={{
              flexGrow: 2,
              p: { xs: 1, sm: 2, md: 3 },
              pt: { xs: 8, sm: 3 },
              px: { xs: 1.5, sm: 4, md: 6, lg: 8 },
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <Routes>
              <Route path="/" element={<Navigate to="/LeadsList" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/LeadsList" element={<LeadsList />} />
              <Route path="/historiqueMailSuivi" element={<HistoriqueMailSuivi />} />
              {isMobilePortrait ? null : (
                <>
                  <Route path="/stockage" element={<Stockage />} />
                  <Route path="/stockageRetard" element={<StockageRetard />} />
                  <Route path="/client" element={<Client />} />
                </>
              )}
            </Routes>
          </Box>
          {isMobilePortrait ? (
            <>
              <Box
                sx={{
                  flexGrow: 1,
                  p: 3,
                  marginLeft: `-${drawerWidth}px`,
                }}
              >
                <Routes>
                  <Route path="/stockage" element={<Stockage />} />{" "}
                </Routes>
              </Box>
            </>
          ) : null}{" "}
          {isMobilePortrait ? (
            <>
              <Box
                sx={{
                  flexGrow: 1,
                  p: 3,
                  marginLeft: `-95px`,
                }}
              >
                <Routes>
                  <Route path="/stockageRetard" element={<StockageRetard />} />{" "}
                </Routes>
              </Box>
            </>
          ) : null}{" "}
          {isMobilePortrait ? (
            <>
              <Box
                sx={{
                  flexGrow: 1,
                  p: 3,
                  // marginLeft: `-${drawerWidth}px`,
                }}
                style={{ width: "90vw" }}
              >
                <Routes>
                  <Route path="/client" element={<Client />} />{" "}
                </Routes>
              </Box>
            </>
          ) : null}
        </Box>
      </LocalizationProvider>
    </PrimeReactProvider>
  );
}

App.propTypes = {
  window: PropTypes.func,
};

export default App;
